// extracted by mini-css-extract-plugin
export var lg = "_l5-7";
export var md = "_l5-6";
export var placeholderContainer = "_l5-1";
export var placeholderIcon = "_l5-2";
export var productImage = "_l5-0";
export var sm = "_l5-5";
export var xl = "_l5-8";
export var xs = "_l5-4";
export var xxs = "_l5-3";